import Fetch from "@/utils/Fetch"

export default {
	namespaced: true,
	state() {
		return {
			managers: null,
		}
	},
	mutations: {
		setManagers(state, managers) {
			state.managers = managers
		},
	},
	actions: {
		async requestManagers({commit, dispatch}, filter) {
			commit('startLoading', 'requestManagers', {root: true})

			const searchUrl = new URL('/', 'http://nahodka.localhost/')

			Object.entries(filter).forEach(([key, value]) => {
				if (value) {
					searchUrl.searchParams.append(key, String(value))
				}
			})

			const response = await Fetch(`managers/${searchUrl.search}`, {
				method: 'GET',
			})

			if (response.success) {
				commit('setManagers', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestManagers', {root: true})

			return {
				...response.data
			}
		},
		async requestCategoryAdmins({commit, dispatch}) {
			commit('startLoading', 'requestCategoryAdmins', {root: true})

			const response = await Fetch(`managers/my-category-admins/`, {
				method: 'GET',
			})

			if (response.success) {
				// commit('setManagers', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestCategoryAdmins', {root: true})

			return {
				...response
			}
		},
		async requestCategoryManagers({commit, dispatch}) {
			commit('startLoading', 'requestCategoryManagers', {root: true})

			const response = await Fetch(`managers/my-category-managers/`, {
				method: 'GET',
			})

			if (response.success) {
				// commit('setManagers', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestCategoryManagers', {root: true})

			return {
				...response
			}
		},

	},
	getters: {
		getManagers: state => state.managers,
	}
}